export enum Features {
    SessionManagementView = 'Session Management View',
    DocumentLibraryView = 'Document Library View',
    ChangeRegisterView = 'Change Register View',
    CourseCatalogueView = 'Course Catalogue View',
    TrainingPlanView = 'Training Plan View',
    TrainingStatusReportView = 'Training Status Report View',
    SkillsSearchView = 'Skills Search View',
    SkillTrainingItems = 'Skill Training Items View'
}
